import { render } from "./Favicon.vue?vue&type=template&id=2fc20fe6"
import script from "./Favicon.vue?vue&type=script&lang=js"
export * from "./Favicon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__